import { render, staticRenderFns } from "./V2OrderUploadInvoice.vue?vue&type=template&id=60f1c292&scoped=true&"
import script from "./V2OrderUploadInvoice.vue?vue&type=script&lang=js&"
export * from "./V2OrderUploadInvoice.vue?vue&type=script&lang=js&"
import style0 from "./V2OrderUploadInvoice.vue?vue&type=style&index=0&id=60f1c292&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f1c292",
  null
  
)

export default component.exports